import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useLocation, useSearchParams } from 'react-router-dom';
import {Helmet} from "react-helmet";

import arrow from './assets/vector_7_1x.webp'
// import arrow1x from './assets/vector_7_1_5x.webp'
import arrow2x from './assets/vector_7_2x.webp'
import arrow3x from './assets/vector_7_3x.webp'
import accept from './assets/frame_1000002363_1x.webp'
// import accept1x from './assets/frame_1000002363_1_5x.webp'
import accept2x from './assets/frame_1000002363_2x.webp'
import accept3x from './assets/frame_1000002363_3x.webp'
import { FadeInSection } from '../landing/fadeIn';

import './waitlist.css';
import ShareModal from './share';

const verified = 'frame_1000002364_1x.webp'
// const verified1x = 'frame_1000002364_1_5x.webp'
const verified2x = 'frame_1000002364_2x.webp'
const verified3x = 'frame_1000002364_3x.webp'
const premium = 'frame_1000002365_1x.webp'
// const premium1x = 'frame_1000002365_1_5x.webp'
const premium2x = 'frame_1000002365_2x.webp'
const premium3x = 'frame_1000002365_3x.webp'
const ad = 'block_1_1_1x.webp'
// const ad1x = 'block_1_1_1_5x.webp'
const ad2x = 'block_1_1_2x.webp'
const ad3x = 'block_1_1_3x.webp'
const crew = 'frame_1000002367_1x.webp'
// const crew1x = 'frame_1000002367_1_5x.webp'
const crew2x = 'frame_1000002367_2x.webp'
const crew3x = 'frame_1000002367_3x.webp'
const challenges = 'gym_1x.webp'
// const challenges1x = 'gym_1_5x.webp'
const challenges2x = 'gym_2x.webp'
const challenges3x = 'gym_3x.webp'
const leaderboard = 'stage_1x.webp'
// const leaderboard1x = 'stage_1_5x.webp'
const leaderboard2x = 'stage_2x.webp'
const leaderboard3x = 'stage_3x.webp'

export default function Waitlist() {
    const [showArrow, setShowArrow] = useState(true);
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')
    const [category, setCategory] = useState('')
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [share, setShare] = useState(false)
    const [referralCode, setReferralCode] = useState<any>('')
    const gifRef = useRef(null)
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams();

    let videoOne_480;
    let videoOne ;
    let videoTwo_480;
    let videoTwo;
    let videoThree_480;
    let videoThree;
    let videoFour_480;
    let videoFour;

    if (location.pathname === '/participate-in-online-fitness-challenges'){
      videoOne_480 = 'hit_480p.mp4'
      videoOne  = 'hit.mp4'
      videoTwo_480 = 'hit2_480p.mp4'
      videoTwo = 'hit2.mp4'
      videoThree_480 = 'hit3_480p.mp4'
      videoThree = 'hit3.mp4'
      videoFour_480 = 'hit4_480p.mp4'
      videoFour = 'hit4.mp4'
    }
    else {
      videoOne_480 = 'Icebucket - 2.mp4'
      videoOne  = 'Icebucket - 2.mp4'
      videoTwo_480 = 'Icebucket - 3.mp4'
      videoTwo = 'Icebucket - 3.mp4'
      videoThree_480 = 'Icebucket - 4.mp4'
      videoThree = 'Icebucket - 4.mp4'
      videoFour_480 = 'Icebucket - 5.mp4'
      videoFour = 'Icebucket - 5.mp4'
    }
  
    useEffect(() => {
      window.scrollTo(0, 0);
      const referralCode = searchParams.get("referralCode")
      setReferralCode(referralCode)
    }, []);
  
    const resumeLottie = () => {
      setShowArrow(false)
    }
  
    const submitUser = () => {
      if(!category && location.pathname === '/participate-in-online-fitness-challenges') {
        setError('Please select category!')
        return;
      }
      setLoading(true)
      setSuccess(false)
      const payload = {
        'email': email,
        'category': category || 'web',
        'referred_by': searchParams.get("referralCode")
      }
      axios.post(`${process.env.REACT_APP_API_ENDPOINT}/waitlist`,payload)
      .then(res => {
        setSuccess(true)
        setLoading(false)
        setError('')
        setReferralCode(res.data?.referral_code)
        setTimeout(() => {
          setShare(true)
        }, 2000);
      })
      .catch((err) => {
        setLoading(false)
        setError(err?.response?.data?.email?.[0] || 'Ooops! something went wrong.')
      })
    }
  
    const updateEmail = (ev) => {
      setEmail(ev.target.value.replace(/ /g, ''))
      setError('')
      setSuccess(false)
    }
  
    const validateEmail = (e) => {
      e.preventDefault()
      if (
        (!/^\S+@\S+\.\S+$/i.test(email)) ||
        email.length > 50
      ) {
        setError('Invalid Email address!');
      } 
      else{
        submitUser()
      }
    }
  
    const onOptionChangeHandler = (event) => {
      setCategory(event.target.value);
      setError('')
      setSuccess(false)
  };

  return (
    <div className='w-100'>
      <Helmet>
          <title>Tigbar | Let's do a challenge | {location.pathname==='/participate-in-online-fitness-challenges' ? 'Online Fitness Challenges' : 'Fun Challenges to do with Friends'}</title>
          <meta name="description" content={location.pathname==='/participate-in-online-fitness-challenges' ? "Discover and participate in online fitness challenges to stay motivated and achieve your fitness goals from home. Join now for a fun." : "Create and participate in fun challenges to do with friends and followers."} />
          <link rel="canonical" href="https://about.tigbar.com/participate-in-online-fitness-challenges" />
      </Helmet>
      {(share || searchParams.get("showPopup")) && <ShareModal fitness={location.pathname==='/participate-in-online-fitness-challenges' ? true:false} referralCode={referralCode} showPopup={searchParams.get("showPopup")} />}
      {/* top section */}
      <FadeInSection>
        <div className={`top-section-container flex-column align-items-center mb-3 mb-md-5`}>
          <div ref={gifRef} className="d-flex col-12 col-sm-6 justify-content-center align-items-center mx-2 mx-sm-0 flex-column" id="gif">
            <div className='d-flex align-items-center justify-content-center w-100'>
              <video autoPlay muted playsInline loop id="primary-video">
                <source type='video/mp4' src={location.pathname === '/participate-in-online-fitness-challenges' ? require('./assets/hit5_small.mp4') : require('./assets/primary.mp4')} />
              </video>
              <video  preload='none' autoPlay muted playsInline loop id="second-video" className={`${!showArrow && 'top-left'}`}>
                <source type='video/mp4' src={process.env.REACT_APP_MEDIA_URL + videoOne_480} media="all and (max-width:480px)"/>
                <source type='video/mp4' src={process.env.REACT_APP_MEDIA_URL + videoOne} />
              </video>
              <video  preload='none' autoPlay muted playsInline loop id="three-video"  className={`${!showArrow && 'bottom-left'}`}>
                <source type='video/mp4' src={process.env.REACT_APP_MEDIA_URL + videoTwo_480} media="all and (max-width:480px)" />
                <source type='video/mp4' src={process.env.REACT_APP_MEDIA_URL + videoTwo} />
              </video>
              <video  preload='none' autoPlay muted playsInline loop id="four-video" className={`${!showArrow && 'top-right'}`}>
                <source type='video/mp4' src={process.env.REACT_APP_MEDIA_URL + videoThree_480} media="all and (max-width:480px)" />
                <source type='video/mp4' src={process.env.REACT_APP_MEDIA_URL + videoThree} />
              </video>
              <video  preload='none' autoPlay muted playsInline loop id="five-video" className={`${!showArrow && 'bottom-right'}`}>
                <source type='video/mp4' src={process.env.REACT_APP_MEDIA_URL + videoFour_480} media="all and (max-width:480px)" />
                <source type='video/mp4' src={process.env.REACT_APP_MEDIA_URL + videoFour} />
              </video>
            </div>
          {showArrow && 
            <>
              <span id="funky-text">Click Accept to participate in {location.pathname !== '/waitlist' ? 'Balance Kick' : 'Ice-Bucket'} Challenge</span>
              <img 
              src={arrow} 
              srcSet={`${arrow}, ${arrow2x} 2x, ${arrow3x} 3x`}
              className='img-fluid' 
              id="arrow"
              alt='down-arrow'
              />          
            </>
          }
          <div className='d-flex align-items-center justify-content-center w-100 mt-4'>
            <img
            src={accept}
            srcSet={`${accept}, ${accept2x} 2x, ${accept3x} 3x`}
            onClick={resumeLottie}
            className='img-fluid w-50' 
            id="accept" 
            alt="accept-btn"
            />
            </div>
          </div>
          <>
          <div className="d-flex flex-column align-items-center px-3"  id="waitlist-div">
            <h1 className="title-text primary-color text-center text-md-left">
              <b>Let's do a Challenge</b>
            </h1>
            <p className="text-dark w-75 text-center">
            The social app for accepting and creating amazing {location.pathname !== '/waitlist' && 'fitness'} challenges with your friends and followers.
            </p>
          </div>
          <form className='row col-12 col-sm-8 col-md-6 justify-content-center' onSubmit={!loading ? validateEmail : () => {return}}>
            <input
            type='email'
            name='email' 
            required={true}
            className="form-control border col-4" 
            placeholder='Email Address'
            value={email}
            onChange={updateEmail}
            />
            {location.pathname !== '/waitlist' && <div className='select-container border col-4 ml-2'>
            <select className="form-control w-100 border-0 pl-0" name='category' required onChange={onOptionChangeHandler}>
              <option>Select your category:</option>
              <option>Yoga</option>
              <option>Calisthenics</option>
              <option>Strongman</option>
              <option>Weightlifting</option>
              <option>Powerlifting</option>
              <option>CrossFit</option>
              <option>Pilates</option>
              <option>Running</option>
              <option>Cycling</option>
              <option>Swimming</option>
              <option>Martial Arts</option>
              <option>Dance Fitness</option>
              <option>HIIT</option>
              <option>Functional Training</option>
              <option>Barre</option>
              <option>Bodyweight Training</option>
              <option>Parkour</option>
              <option>Other</option>
            </select>
            </div>}
            <button
              className="btn btn-primary ml-2"
              type='submit'
            >
              {loading ? <div className="spinner-border spinner-border-sm text-light"></div> : 
              window.innerWidth > 500 ? 'Join Waitlist' : 'Go'
              }
            </button>
          </form>
          {success && <h5 className='mt-4 px-2 text-center text-secondary'>Excited to have you onboard!😎 <br/>You'll recieve an email when Tigbar go live!!</h5>}
          {error && <p className='error mt-2'>{error}</p>}
          </>
        </div>
      </FadeInSection>
      {/* end top section */}
      {/* parallex section */}
      {location.pathname !== '/waitlist' && 
      <div className='d-flex justify-content-center align-items-center bg-light my-5 py-5'>
        <FadeInSection>
          <h1 className='text-center'>
          Build your fitness crew
          </h1>
          <div className='row justify-content-center'>
          <div className='benefit-box row col-10 py-3 col-md-3'>
            <img
            src={process.env.REACT_APP_MEDIA_URL + crew}
            srcSet={`${process.env.REACT_APP_MEDIA_URL + crew}, ${process.env.REACT_APP_MEDIA_URL + crew2x} 2x, ${process.env.REACT_APP_MEDIA_URL + crew3x} 3x`}
            loading='lazy'
            alt='fitness-icons'
            className='img-fluid benefits-img' 
            />
            <div className='col-8'>
            <h5>
              Discover Fitness Categories
            </h5>
            <p className="text-secondary">
            Explore various fitness categories, from yoga to weightlifting, to find the perfect crew for you.
            </p>
            </div>
          </div>
          <div className='benefit-box row col-10 py-3 col-md-3'>
            <img
            src={process.env.REACT_APP_MEDIA_URL + challenges}
            srcSet={`${process.env.REACT_APP_MEDIA_URL + challenges}, ${process.env.REACT_APP_MEDIA_URL + challenges2x} 2x, ${process.env.REACT_APP_MEDIA_URL + challenges3x} 3x`}
            loading='lazy'
            alt='fitness-challenges'
            className='img-fluid benefits-img' 
            />
            <div className='col-8'>
            <h5>
              Exciting Fitness Challenges
            </h5>
            <p className="text-secondary">
              Discover and join exciting fitness challenges, compete with others, and have a blast
            </p>
            </div>
          </div>
          <div className='benefit-box row col-10 py-3 col-md-3'>
            <img 
            src={process.env.REACT_APP_MEDIA_URL + leaderboard}
            srcSet={`${process.env.REACT_APP_MEDIA_URL + leaderboard}, ${process.env.REACT_APP_MEDIA_URL + leaderboard2x} 2x, ${process.env.REACT_APP_MEDIA_URL + leaderboard3x} 3x`}
            loading='lazy'
            alt='leaderboards' 
            className='img-fluid benefits-img' 
            />
            <div className='col-8'>
            <h5>
            LeaderFit
            </h5>
            <p className="text-secondary">
              Find out who can do it better than you with the power of leaderboards
            </p>
            </div>
          </div>
          </div>
        </FadeInSection>
      </div>
      }
      {/* end parallex section */}
      {/* parallex section */}
      <div className='d-flex justify-content-center align-items-center bg-light my-5 py-5'>
        <FadeInSection>
          <h1 className='text-center'>
          Early Bird Advantage
          </h1>
          <div className='row justify-content-center'>
          <div className='benefit-box row col-10 py-3 col-md-3'>
            <img
            src={process.env.REACT_APP_MEDIA_URL + verified}
            srcSet={`${process.env.REACT_APP_MEDIA_URL + verified}, ${process.env.REACT_APP_MEDIA_URL + verified2x} 2x, ${process.env.REACT_APP_MEDIA_URL + verified3x} 3x`}
            loading='lazy'
            alt='verified-check'
            className='img-fluid benefits-img' 
            />
            <div className='col-8'>
            <h5>
              Get Verified
            </h5>
            <p className="text-secondary">
            Eligible for premium verification with easy steps that gives boosts to your content.
            </p>
            </div>
          </div>
          <div className='benefit-box row col-10 py-3 col-md-3'>
            <img
            src={process.env.REACT_APP_MEDIA_URL + premium}
            srcSet={`${process.env.REACT_APP_MEDIA_URL + premium}, ${process.env.REACT_APP_MEDIA_URL + premium2x} 2x, ${process.env.REACT_APP_MEDIA_URL + premium3x} 3x`}
            loading='lazy'
            alt='premium-benefits'
            className='img-fluid benefits-img' 
            />
            <div className='col-8'>
            <h5>
              Access to Exclusive Features
            </h5>
            <p className="text-secondary">
            Easily Unlock Tigbar's Exclusive Perks and Level Up Your Social Experience!
            </p>
            </div>
          </div>
          <div className='benefit-box row col-10 py-3 col-md-3'>
            <img
            src={process.env.REACT_APP_MEDIA_URL + ad}
            srcSet={`${process.env.REACT_APP_MEDIA_URL + ad}, ${process.env.REACT_APP_MEDIA_URL + ad2x} 2x, ${process.env.REACT_APP_MEDIA_URL + ad3x} 3x`}
            loading='lazy'
            alt='verified-check'
            className='img-fluid benefits-img' 
            />
            <div className='col-8'>
            <h5>
              Ad-free Experience
            </h5>
            <p className="text-secondary">
            Enjoy Tigbar without interruptions. No ads means pure social fun, all the time.
            </p>
            </div>
          </div>
          </div>
        </FadeInSection>
      </div>
      {/* end parallex section */}
    </div>
  )
}
